import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import FileUploader from 'modules/finance/components/FileUploader'
import { useCreateWorkAreaMap } from 'modules/space_control/hooks/useCreateWorkAreaMap'

interface Props {
  workAreaId: number
  onClose: () => void
  onSuccess: () => void
}

const FileUploaderModal = ({ workAreaId, onClose, onSuccess }: Props) => {
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined)
  const { createWorkAreaMap } = useCreateWorkAreaMap()

  const handleUpload = async () => {
    if (!selectedFile) return

    await createWorkAreaMap({ workAreaId, image: selectedFile })
    onSuccess()
    onClose()
  }

  return (
    <Modal
      title={i18n.t('settings.locations.location.work_areas.edit.title')}
      onClose={onClose}
      onSubmit={handleUpload}
      footer={
        <Button submit disabled={!selectedFile} onClick={handleUpload}>
          {i18n.t('settings.locations.location.work_areas.edit.button')}
        </Button>
      }
    >
      <Box gap="s16">
        <FileUploader
          placeholder={i18n.t('settings.locations.location.work_areas.map.image_placeholder')}
          description=""
          selectedFile={selectedFile}
          onDrop={(files) => setSelectedFile(files[0])}
          acceptedFormats={{ 'image/*': [] }}
        />
      </Box>
    </Modal>
  )
}

export default FileUploaderModal
